<!-- <app-header [user]="user()" /> -->
<header class="www-eve-tic__hea"><img src="assets/images/ppd.webp" alt="PPD" /></header>

@if (successFullyRegistered()) {
  <div class="www-tha-you">
    <section class="www-tha-you__con">
      <div class="www-tha-you__con__red-cir" [appAnimate]="'fadeInRight'" delay="800"></div>
      <div class="www-tha-you__con__yel-cir" [appAnimate]="'fadeInLeft'" delay="900"></div>

      <img
        class="www-tha-you__con__img"
        alt="Woman"
        src="assets/images/pages/thank-you/woman.webp"
        [appAnimate]="'fadeInLeft'"
      />
      <div class="www-tha-you__con__text" [appAnimate]="'fadeInRight'">
        <h1 class="www-tha-you__con__text__tit f-open-sans">Dziękujemy!</h1>
        <p class="www-tha-you__con__text__des f-open-sans">Twój bilet został zatwierdzony!</p>
      </div>
    </section>
  </div>
} @else if (eventInactive()) {
  <div class="www-tha-you">
    <section class="www-tha-you__con">
      <div class="www-tha-you__con__red-cir" [appAnimate]="'fadeInRight'" delay="800"></div>
      <div class="www-tha-you__con__yel-cir" [appAnimate]="'fadeInLeft'" delay="900"></div>

      <img
        class="www-tha-you__con__img"
        alt="Woman"
        src="assets/images/pages/thank-you/woman.webp"
        [appAnimate]="'fadeInLeft'"
      />
      <div class="www-tha-you__con__text" [appAnimate]="'fadeInRight'">
        <h1 class="www-tha-you__con__text__tit f-open-sans">Nie znaleziono wydarzenia!</h1>
        <p class="www-tha-you__con__text__des f-open-sans">
          Wydarzenie dobiegło końca lub Twój bilet został już zatwierdzony!
        </p>
      </div>
    </section>
  </div>
} @else {
  <div class="www-eve-tic pb-5" [appAnimate]="'landing'" [speed]="'fast'" [aos]="0.1" delay="100">
    <section class="www-eve-tic__con">
      <form
        [formGroup]="formGroup"
        [ngxsFormClearOnDestroy]="true"
        [ngxsFormDebounce]="20"
        [ngxsForm]="'eventTicket.form'"
        class="www-form www-eve-tic__con__form"
        appInvalidControlScroll
        [appAnimate]="'fadeInLeft'"
        [speed]="'fast'"
      >
        <h3 class="www-eve-tic__con__form__ti">
          <span [appAnimate]="'landing'" [speed]="'fast'" [aos]="0.1" delay="100">Cześć!</span><br />
          <span [appAnimate]="'landing'" [speed]="'fast'" [aos]="0.1" delay="400">Miło Cię widzieć.</span><br />
          <span [appAnimate]="'landing'" [speed]="'fast'" [aos]="0.1" delay="800"
            >Potwierdź swoją obecność w naszym wydarzeniu.</span
          >
        </h3>

        @if (!details()) {
          <div class="row">
            <div class="col-12">
              <div class="group">
                <label for="code">Wprowadź kod biletu</label>
                <input
                  [(ngModel)]="code"
                  [ngModelOptions]="{ standalone: true }"
                  id="code"
                  type="text"
                  autocomplete="off"
                />
              </div>
              <!-- <app-validate-message [control]="f.firstname" /> -->
            </div>

            <div class="col-12 my-3">
              <button (click)="onGetDetails()" type="button" class="www-black-btn">Przejdź dalej</button>
            </div>
          </div>
        } @else {
          <h4 class="www-eve-tic__con__form__des">
            <span [appAnimate]="'landing'" [speed]="'fast'" [aos]="0.1" delay="100">
              {{ 'Szkolenie: ' + details()?.training?.name }} &nbsp;&nbsp;{{
                details()?.start_date | date: 'dd.MM.yyyy'
              }}</span
            >
          </h4>
          <div class="row">
            <div class="col-12">
              <div class="group">
                <input
                  [appInputValidator]="f.firstname"
                  [formControlName]="'firstname'"
                  id="firstname"
                  type="text"
                  autocomplete="off"
                />
                <label for="firstname">Imię posiadacza biletu</label>
              </div>
              <app-validate-message [control]="f.firstname" />
            </div>

            <div class="col-12">
              <div class="group">
                <input
                  [appInputValidator]="f.lastname"
                  [formControlName]="'lastname'"
                  id="lastname"
                  type="text"
                  autocomplete="off"
                />
                <label for="lastname">Nazwisko posiadacza biletu</label>
              </div>
              <app-validate-message [control]="f.lastname" />
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <div class="group">
                <input
                  [appInputValidator]="f.email"
                  [formControlName]="'email'"
                  id="email"
                  type="email"
                  autocomplete="off"
                />
                <label for="email">Podaj adres e-mail</label>
              </div>
              <app-validate-message [control]="f.email" />
            </div>

            <div class="col-12">
              <div class="group">
                <input
                  [appInputValidator]="f.mobile"
                  [formControlName]="'mobile'"
                  id="mobile"
                  name="mobile"
                  type="text"
                  autocomplete="off"
                  [mask]="f.mobile.disabled ? null : '000 000 000'"
                  prefix="+48 "
                  [dropSpecialCharacters]="true"
                />
                <label for="mobile">Podaj numer telefonu komórkowego</label>
              </div>
              <app-validate-message [control]="f.mobile" />
            </div>
          </div>

          <div class="row www-eve-tic__con__form__con mb-lg-5 mb-4">
            <div class="col-12 mb-3">
              <p class="www-eve-tic__con__form__con__p mb-4">Zgody</p>

              <div class="mb-1">
                <div class="group">
                  <input type="checkbox" id="agreementTraining" [formControlName]="'agreementTraining'" />
                  <label for="agreementTraining">
                    Akceptuję
                    <a [href]="details()?.training?.rules_file_path" target="_blank">regulamin</a> wydarzenia<sup
                      >*</sup
                    ></label
                  >
                </div>

                <app-validate-message [control]="f.agreementTraining" />
              </div>
            </div>
            <div class="col-12 mb-3">
              <p class="www-eve-tic__con__form__con__des">
                Wyrażam zgodę na kontakt przez L’Oréal Polska Sp. z o.o. z siedzibą w Warszawie (00-844 przy ul.
                Grzybowskiej 62) w celu marketingu bezpośredniego, w tym przesyłania informacji handlowych, w
                szczególności przesyłania informacji handlowych dotyczących produktów marek (L’Oréal Professionnel,
                Kérastase, Matrix, Biolage, Redken) za pośrednictwem następujących kanałów komunikacji:
              </p>
            </div>
            <div class="col-12">
              <div>
                <input type="checkbox" id="agreementEmail" [formControlName]="'agreementEmail'" />
                <label class="small" for="agreementEmail">E-mail</label>
              </div>
              <app-validate-message [control]="f.agreementEmail" />
            </div>

            <div class="col-12">
              <div>
                <input type="checkbox" id="agreementSms" [formControlName]="'agreementSms'" />
                <label class="small" for="agreementSms">SMS</label>
              </div>
              <app-validate-message [control]="f.agreementSms" />
            </div>
            <div class="col-12">
              <div>
                <input type="checkbox" id="agreementPhone" [formControlName]="'agreementPhone'" />
                <label class="small" for="agreementPhone">Połączenie telefoniczne</label>
              </div>
              <app-validate-message [control]="f.agreementPhone" />
            </div>
            <div class="col-12">
              <div>
                <input type="checkbox" id="agreementWhatsApp" [formControlName]="'agreementWhatsApp'" />
                <label class="small" for="agreementWhatsApp">Whatsapp</label>
              </div>
              <app-validate-message [control]="f.agreementWhatsApp" />
            </div>
            <div class="col-12 mb-3">
              <small class="small">*pole obowiązkowe</small>
            </div>

            <div class="col-12">
              <p class="www-eve-tic__con__form__con__des">
                Administratorem Pani/Pana danych osobowych jest L’Oréal Polska Sp. z o.o., z siedzibą w Warszawie
                (00-844) przy ul. Grzybowskiej 62. Kontakt z Inspektorem Ochrony Danych możliwy jest za pośrednictwem
                adresu e-mail: personal-da&#64;loreal.com. Szczegółowe informacje dotyczące przetwarzania danych
                osobowych zawarte są w
                <a target="_blank" href="#">Polityce Prywatności.</a>.
              </p>
            </div>
          </div>

          <div class="row www-eve-tic__btn my-4 my-md-0">
            <div class="col-12">
              <button (click)="onRegister()" class="www-black-btn">Potwierdź</button>
            </div>
          </div>
        }
      </form>

      <div class="www-eve-tic__con__rig">
        <img
          class="www-tha-you__con__img"
          alt="Woman"
          src="assets/images/pages/thank-you/woman.webp"
          [appAnimate]="'fadeInLeft'"
        />
      </div>
    </section>
  </div>
}
